import React from 'react';
import { Redirect } from 'react-router-dom';

import { ROUTER_URL } from '../../const/ROUTER_URL';

const NotFound = () => {
    return (
        <Redirect to={ROUTER_URL.SHOPS} />
    );
};

export default NotFound;
